import { useMemo } from "react";
import { Button, Card } from "react-bootstrap";
import { FaMapMarkerAlt } from "react-icons/fa";

const DetailLocation = ({ property }) => {
  const mapQuery = useMemo(() => {
    const query = [property?.address, property?.district, property?.city, property?.province]
      .filter(Boolean)
      .join(", ");

    return query ? encodeURIComponent(query) : "";
  }, [property]);

  const locationText = useMemo(() => {
    return [property?.village, property?.district, property?.city, property?.province]
      .filter(Boolean)
      .join(", ");
  }, [property]);

  return (
    <Card className="detail-card">
      <Card.Body className="detail-card-body">
        <h3 className="section-title">Lokasi Properti</h3>

        <div className="detail-location-summary">
          <div className="detail-location-summary-label">Alamat Lengkap</div>
          <div className="detail-location-summary-value">
            {property?.address || "-"}
          </div>
          <div className="detail-location-summary-sub">
            {locationText || "-"}
          </div>
        </div>

        <div className="detail-map-wrap">
          {mapQuery ? (
            <iframe
              src={`https://www.google.com/maps?q=${mapQuery}&z=16&output=embed`}
              className="detail-map-frame"
              loading="lazy"
              title="Lokasi Properti"
            />
          ) : (
            <div className="detail-map-placeholder">
              <FaMapMarkerAlt size={30} />
              <div>Lokasi belum tersedia</div>
            </div>
          )}

          <Button
            variant="outline-primary"
            className="detail-map-button"
            href={mapQuery ? `https://www.google.com/maps/search/?api=1&query=${mapQuery}` : "#"}
            target="_blank"
            rel="noreferrer"
          >
            Lihat Perkiraan Lokasi
          </Button>
        </div>
      </Card.Body>
    </Card>
  );
};

export default DetailLocation;
